
import i18n from '@/i18n';
export const STANDARD_TRAFFIC_SIZE_TYPE_KEY = [
  { key: 'parentTrafficSize', label: i18n.t('异常流量(MB)'), type: 0 },
  { key: 'httpType', label: i18n.t('http流量(MB)'), type: 0 },
  { key: 'tcpType', label: i18n.t('tcp流量(MB)'), type: 0 },
  { key: 'udpType', label: i18n.t('udp流量(MB)'), type: 0 },
  { key: 'unknownType', label: i18n.t('其他流量(MB)'), type: 0 }];
